import { Circle } from "@phosphor-icons/react"
import { Divider, Tag } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"

export const AdvanceAdjustment = ({
  createdAt,
  tradeId,
  supplierName,
  adjustment,
  payableAmount,
  releasedAmount,
  remaining,
  totalAdvanceAvailable,
  usedInOtherTrades,
  isTrade = true,
  loading = false,
  tradeAmount,
}: {
  createdAt?: any
  tradeId?: any
  supplierName?: any
  releasedAmount?: any
  totalAdvanceAvailable?: any
  payableAmount?: any
  adjustment?: any
  remaining?: any
  usedInOtherTrades?: any
  isTrade?: boolean
  loading?: boolean
  tradeAmount?: any
}) => {
  return (
    <div className="text-xs">
      <h1 className="text-yellow-500 font-700">
        ADVANCE ADJUSTMENT ({createdAt})
      </h1>
      <Tag
        className="!bg-blue-600 mt-2 text-[10px] !rounded-md"
        intent="info"
        textClassName="flex gap-4 items-center !font-mono"
      >
        <span>
          {isTrade ? "Trade" : "Receipt"} ID #{tradeId}
        </span>
        <span>
          <Circle weight="fill" size={5} />
        </span>
        <span> {supplierName}</span>
      </Tag>
      <Divider className="border-t-2 border-blue-600 my-2" />
      {loading ? (
        <div className="py-4 text-center text-blue-300 font-500">
          Loading...
        </div>
      ) : (
        <>
          <div className="rounded-lg text-xs flex gap-2 flex-col !text-white">
            <div className="flex justify-between">
              <span className="font-500">{`${
                isTrade ? "Trade" : "Receipt"
              } Total:`}</span>
              <span className="font-700">{inr(tradeAmount || 0)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-500">Released Adv. Amount:</span>
              <span className="font-700">{inr(releasedAmount || 0)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-500">
                Used in Other {`${isTrade ? "Trade" : "Receipt"}`}:
              </span>
              <span className="font-700">{inr(usedInOtherTrades || 0)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-500">Total Advance Available:</span>
              <span className=" font-700">
                {inr((releasedAmount || 0) - (usedInOtherTrades || 0))}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-500">Payable Amount:</span>
              <span className="font-700">
                {inr((payableAmount || 0) + (adjustment || 0))}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-500 ">
                Adjusted for this {`${isTrade ? "Trade" : "Receipt"}`}:
              </span>
              <span className="font-700">{inr(adjustment || 0)}</span>
            </div>
            <Divider className="border-blue-600 border-t-2" />
            <div className="flex justify-between">
              <span className="font-500 text-green-300">
                Remaining Advance:
              </span>
              <span className="text-green-300 font-700">
                {inr(remaining || 0)}
              </span>
            </div>
          </div>
          <div className="px-4">
            <Tag
              className="!bg-blue-600 mt-2 !text-right !rounded-md border-blue-400 border-1 text-2xs justify-self-center !w-full"
              intent="info"
              textClassName="flex gap-4 items-center !text-right !font-mono"
            >
              <span>
                Calculation: {inr(releasedAmount)} - {inr(adjustment || 0 || 0)}{" "}
                = {inr(remaining || 0)}
              </span>
            </Tag>
          </div>
          <Divider className="border-blue-600 border-t-2 my-2" />
          <span className="italic">
            {inr(adjustment || 0)} was adjusted from the released advance,
            leaving {inr(remaining || 0)} available for future{" "}
            {`${isTrade ? "Trade" : "Receipt"}`}.
            <br />
            This advance balance belongs only to {supplierName} and is not
            shared with other customers.
          </span>
        </>
      )}
    </div>
  )
}
